import { defineWebModule } from '@portal/web-sdk';
import { manifest } from '../manifest.js';
import { en, vi } from './translations.js';

/** No pages of its own: files appear inside the modules that own them. */
export const coreFilesWebModule = defineWebModule({
  manifest,
  translations: { vi, en },
  routes: [],
});
